import { useCallback } from 'react';
import PropTypes from 'prop-types';

import { useNavigate } from 'react-router';

import { connect } from 'react-redux';

import { Button } from 'Components/LegacyButton';

import { productsCategories } from 'constants/products';

import * as checkoutCartActions from 'dux/checkoutCart/actions';
import { trackPreselect } from 'dux/tracking/actions';
import useProductDetailsCTAFn from 'dux/userFlows/useProductDetailsCTA';

const ProductCTA = ({
  dataFrom,
  productName,
  render,
  label,
  slug,
  theme,
  variant,
  useProductDetailsCTA,
  recommendOnCart,
  productCategory,
  loadCart,
  customOnClick,
  ...props
}) => {
  const params = useProductDetailsCTA({ productName, slug, productCategory });
  const navigate = useNavigate();
  const recommend = useCallback(
    (theSlug, { executeCallback = true }) => {
      recommendOnCart({
        productSlug: theSlug,
        locationId: `pdp-${theSlug}`,
        // We want to make sure that the breadcrumbs call is finished before starting a cart API call
        onSuccess: executeCallback ? () => navigate(params.to) : () => {},
        productCategory,
      });
    },
    [recommendOnCart, productCategory, navigate]
  );

  const onClick = (e, executeCallback = true) => {
    if (customOnClick) {
      customOnClick(params.to);
    } else if (slug) {
      recommend(slug, { executeCallback });
    }
    if (!executeCallback) {
      navigate(params.to);
    }
    e.preventDefault();
  };

  if (render) {
    return typeof render === 'function' ? render(params) : render;
  }

  return (
    <form onSubmit={e => onClick(e, params.shouldQueueBreadcrumb)}>
      <Button
        data-click={params.dataClick}
        data-from={dataFrom}
        disabled={Boolean(params.disabled)}
        isLoading={params.isLoading ?? false}
        type="submit"
        variant={variant ?? theme}
        {...props}
      >
        {label || params.label}
      </Button>
    </form>
  );
};

ProductCTA.propTypes = {
  dataFrom: PropTypes.string,
  productName: PropTypes.string,
  render: PropTypes.func,
  label: PropTypes.string,
  /**
   * @deprecated
   * please use variant instead.
   */
  theme: PropTypes.string,
  variant: PropTypes.string,
  slug: PropTypes.string,
  productCategory: PropTypes.string,
  useProductDetailsCTA: PropTypes.func,
  recommendOnCart: PropTypes.func,
  loadCart: PropTypes.func,
  customOnClick: PropTypes.func,
};

ProductCTA.defaultProps = {
  dataFrom: 'consultation-cta',
  render: null,
  /** @deprecated
   * Please use variant instead.
   */
  theme: 'sorbet',
  variant: null,
  productName: null,
  label: null,
  slug: null,
  useProductDetailsCTA: useProductDetailsCTAFn,
  recommendOnCart: () => {},
  loadCart: () => {},
  customOnClick: null,
  productCategory: productsCategories.HAIRCARE,
};

export default connect(null, {
  recommendOnCart: trackPreselect,
  loadCart: checkoutCartActions.loadCart,
})(ProductCTA);
